export default __webpack_public_path__ + "static/media/img-1.589b30ad.png";